import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id D0825387-637B-4EB5-BCF5-470A7FCE1F05
 * name unicorn-variant
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/unicorn-variant.svg
 * tags
 * - Animal 
 */
export const UnicornVariantIcon = createSvgIcon(<><path d="M20 12V19L17 20L14 15.33C13.71 14.89 13 15.14 13.08 15.67L14 23L4 18L4.96 12.75C5.56 9.42 8.46 7 11.84 7H13L19 1L17 7H20L18.42 9.37C19.36 9.88 20 10.86 20 12Z" /></>, 'UnicornVariantIcon');
export default UnicornVariantIcon